export const TickIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1681_197210)">
        <path
          d="M6.26795 23.4221L12.5791 17.111C12.9346 16.7555 13.3494 16.5848 13.8235 16.599C14.2976 16.6132 14.7124 16.7987 15.0679 17.1555C15.3939 17.511 15.5568 17.9258 15.5568 18.3999C15.5568 18.874 15.3939 19.2888 15.0679 19.6444L7.55684 27.1999C7.20128 27.5555 6.78647 27.7332 6.31239 27.7332C5.83832 27.7332 5.4235 27.5555 5.06795 27.1999L1.24572 23.3777C0.919799 23.0518 0.756836 22.6369 0.756836 22.1332C0.756836 21.6295 0.919799 21.2147 1.24572 20.8888C1.57165 20.5629 1.98647 20.3999 2.49017 20.3999C2.99387 20.3999 3.40869 20.5629 3.73461 20.8888L6.26795 23.4221ZM6.26795 9.19991L12.5791 2.8888C12.9346 2.53324 13.3494 2.36257 13.8235 2.3768C14.2976 2.39102 14.7124 2.5765 15.0679 2.93324C15.3939 3.2888 15.5568 3.70361 15.5568 4.17769C15.5568 4.65176 15.3939 5.06658 15.0679 5.42213L7.55684 12.9777C7.20128 13.3332 6.78647 13.511 6.31239 13.511C5.83832 13.511 5.4235 13.3332 5.06795 12.9777L1.24572 9.15546C0.919799 8.82954 0.756836 8.41472 0.756836 7.91102C0.756836 7.40732 0.919799 6.9925 1.24572 6.66657C1.57165 6.34065 1.98647 6.17769 2.49017 6.17769C2.99387 6.17769 3.40869 6.34065 3.73461 6.66657L6.26795 9.19991Z"
          fill="#1181E8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1681_197210">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TickIcon;
